module.exports = __webpack_public_path__ + "img/woman-handshake2-opti.0e43712c.jpg";